import { useEffect, useMemo } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, { PaginationProvider }  from "react-bootstrap-table2-paginator";
import * as actions from "../../../../_redux/person-assignment/PersonAssignmentAction";
import * as uiHelpers from "../TeachersUIHelpers";
import { 
  getSelectRow, 
  getHandlerTableChange,  
  NoRecordsFoundMessage, 
  PleaseWaitMessage, 
  sortCaret
} from "../../../../../../../_metronic/_helpers";
import { Pagination } from "../../../../../../../_metronic/_partials/controls";
import { useTeachersUIContext } from "../TeachersUIContext";

export function TeachersTable() {
  // Teachers UI Context
  const teachersUIContext = useTeachersUIContext();
  const teachersUIProps = useMemo(() => {
    return {
      ids: teachersUIContext.ids,
      setIds: teachersUIContext.setIds,
      queryParams: teachersUIContext.queryParams,
      setQueryParams: teachersUIContext.setQueryParams
    };
  }, [teachersUIContext]);

  // Getting curret state of Teachers list from store (Redux)
  const { currentState } = useSelector(
    (state) => ({ currentState: state.personAssignment }),
    shallowEqual
  );
  const { totalCount, personIds, entities, listLoading } = currentState;
  
  // Teacher Redux state
  const dispatch = useDispatch();

  useEffect(() => {
    teachersUIProps.setIds(personIds);
    dispatch(actions.getTeachers(teachersUIProps.queryParams));
    return () => dispatch(actions.cleanPeople());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [personIds, teachersUIProps.queryParams, dispatch]);

  // Table columns
  const columns = [
    {
      dataField: "name",
      text: "Adı",
      sort: true,
      sortCaret: sortCaret
    },
    {
      dataField: "surname",
      text: "Soyadı",
      sort: true,
      sortCaret: sortCaret
    },
    {
      dataField: "branch",
      text: "Branşı",
      sort: true,
      sortCaret: sortCaret
    },
    {
      dataField: "mobilePhone1",
      text: "Telefon",
      sort: true,
      sortCaret: sortCaret,
    },
    {
      dataField: "email1",
      text: "Email",
      sort: true,
      sortCaret: sortCaret,
    }
  ];

  // Table pagination properties
  const paginationOptions = {
    custom: true,
    totalSize: totalCount,
    sizePerPageList: uiHelpers.sizePerPageList,
    sizePerPage: teachersUIProps.queryParams.pageSize,
    page: teachersUIProps.queryParams.pageNumber
  };
  
  return (
    <PaginationProvider pagination={paginationFactory(paginationOptions)}>
      {({ paginationProps, paginationTableProps }) => {
        return (
          <Pagination
            isLoading={listLoading}
            paginationProps={paginationProps}
          >
            <BootstrapTable
              wrapperClasses="table-responsive"
              classes="table table-head-custom table-vertical-center overflow-hidden"
              bootstrap4
              bordered={false}
              remote
              keyField="id"
              data={entities ?? []}
              columns={columns}
              defaultSorted={uiHelpers.defaultSorted}
              onTableChange={getHandlerTableChange(
                teachersUIProps.setQueryParams
              )}
              selectRow={getSelectRow({
                entities,
                ids: teachersUIProps.ids,
                setIds: teachersUIProps.setIds
              })}
              {...paginationTableProps}
            >
              <PleaseWaitMessage entities={entities} />
              <NoRecordsFoundMessage entities={entities} />
            </BootstrapTable>
          </Pagination>
        );    
      }}
    </PaginationProvider>  
  );
}